import { Link } from "react-router-dom";
import { useApi } from "@/lib/api";
import { AdminHeader } from "@/pages/admin/AdminLayout";

const CARDS = [
  { k: "sale", label: "Homes & Land", to: "/admin/listings?kind=sale" },
  { k: "rent", label: "Places to Stay", to: "/admin/listings?kind=rent" },
  { k: "posts", label: "Stories", to: "/admin/posts" },
  { k: "directory", label: "Directory entries", to: "/admin/directory" },
  { k: "unread", label: "New inquiries", to: "/admin/inquiries" },
  { k: "pending_retreats", label: "Retreats to approve", to: "/admin/retreats" },
];

export default function AdminOverview() {
  const { data: stats } = useApi("/admin/stats", {});
  const { data: inquiries } = useApi("/admin/inquiries", []);
  return (
    <div data-testid="admin-overview">
      <AdminHeader title="Welcome back">
        <Link to="/admin/listings/new?kind=sale" className="btn-primary" data-testid="overview-new-sale">New home / land listing</Link>
        <Link to="/admin/posts/new?ai=1" className="btn-outline" data-testid="overview-new-ai-post">Write a blog with AI</Link>
        <Link to="/admin/listings/new?kind=rent" className="btn-outline" data-testid="overview-new-rent">New place to stay</Link>
      </AdminHeader>
      <div className="grid gap-5 sm:grid-cols-2 lg:grid-cols-5">
        {CARDS.map((c) => (
          <Link key={c.k} to={c.to} className="card-lift rounded-2xl border border-clay bg-white p-6" data-testid={`stat-${c.k}`}>
            <p className="text-xs font-bold uppercase tracking-[0.18em] text-moss">{c.label}</p>
            <p className="mt-3 font-display text-5xl font-black text-forest">{stats[c.k] ?? "–"}</p>
          </Link>
        ))}
      </div>
      <div className="mt-10 rounded-2xl border border-clay bg-white p-6">
        <div className="flex items-center justify-between">
          <h2 className="text-xl font-black text-ink">Latest inquiries</h2>
          <Link to="/admin/inquiries" className="text-sm font-bold text-forest hover:underline">View all</Link>
        </div>
        <div className="mt-4 divide-y divide-clay">
          {inquiries.length === 0 && <p className="py-6 text-sm text-moss">No inquiries yet.</p>}
          {inquiries.slice(0, 5).map((q) => (
            <div key={q.id} className="flex flex-col justify-between gap-1 py-4 sm:flex-row" data-testid={`overview-inquiry-${q.id}`}>
              <div>
                <p className="font-bold text-ink">{q.first_name} {q.last_name} <span className="font-medium text-moss">· {q.email}</span></p>
                <p className="line-clamp-1 text-sm text-moss">{q.message}</p>
              </div>
              <p className="shrink-0 text-xs font-bold text-sage">{q.listing_title || "General"} · {new Date(q.created_at).toLocaleDateString()}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
